import React, { useEffect } from 'react';
import { t } from 'Locale/index';
import { Device } from 'DeviceUtils';
import Theme from 'Theme';
import { ScrollView, Text, Pressable, View } from 'react-native';
import { Icon } from 'LocalGluons/index';
import { logEvent } from 'AppManager';
import Checkbox from '../../../Checkbox';
import { EPG_LIST_TYPES } from '../../../../../../../options';

const CategoriesFilterPage = ({
    // TODO: Fix linting error https://jira.24i.com/browse/PRJ1260EXT-4659
    // eslint-disable-next-line react/prop-types
    theme,
    // TODO: Fix linting error https://jira.24i.com/browse/PRJ1260EXT-4659
    // eslint-disable-next-line react/prop-types
    categories,
    // TODO: Fix linting error https://jira.24i.com/browse/PRJ1260EXT-4659
    // eslint-disable-next-line react/prop-types
    onClose,
    // TODO: Fix linting error https://jira.24i.com/browse/PRJ1260EXT-4659
    // eslint-disable-next-line react/prop-types
    onBack,
    // TODO: Fix linting error https://jira.24i.com/browse/PRJ1260EXT-4659
    // eslint-disable-next-line react/prop-types
    onSelected,
    // TODO: Fix linting error https://jira.24i.com/browse/PRJ1260EXT-4659
    // eslint-disable-next-line react/prop-types
    onReset,
    // TODO: Fix linting error https://jira.24i.com/browse/PRJ1260EXT-4659
    // eslint-disable-next-line react/prop-types
    listMode
}) => {
    let heading = t('COMMON.CHANNEL_MAP_LIVE');
    if (listMode === EPG_LIST_TYPES.ALL) {
        heading = t('COMMON.CHANNEL_MAP_ALL');
    } else if (listMode === EPG_LIST_TYPES.FAVORITES) {
        heading = t('COMMON.CHANNEL_MAP_FAVOURITE');
    }

    useEffect(() => {
        logEvent({
            type: 'user-flow',
            subtype: 'epg',
            content1: 'epg-filter',
            content2: 'genra',
            context: '/epg/genra'
        });
    }, []);

    const trashCanSize = Device.isPhone ? 30 : 20;

    const resetFilter = () => {
        onReset(false);
    };

    return (
        <ScrollView>
            <View
                style={[
                    theme.window.line,
                    { flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }
                ]}
            >
                <Icon
                    name="arrow_left"
                    tintColor={Theme.secondaryTextColor}
                    style={{
                        width: 30,
                        height: 30,
                        marginRight: Theme.BU + 30
                    }}
                    onPress={onBack}
                />
                <Text numberOfLines={1} style={[theme.window.lineText, { fontSize: 22 }]}>
                    {heading}
                </Text>
                <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                    <Icon
                        name="delete"
                        style={{
                            width: trashCanSize,
                            height: trashCanSize,
                            marginRight: Theme.BU / 2
                        }}
                        onPress={resetFilter}
                        tintColor="#00a0de"
                    />
                    <Icon
                        name="close_grey"
                        style={{
                            width: 30,
                            height: 30,
                            marginRight: Theme.BU / 2
                        }}
                        onPress={onClose}
                    />
                </View>
            </View>
            <Pressable
                key="categoryFilterAll"
                style={[theme.window.line, { flexDirection: 'row' }]}
                onPress={resetFilter}
            >
                <View style={{ flexDirection: 'row' }}>
                    <Text style={theme.window.lineText}>{t('COMMON.ALL')}</Text>
                    <Text style={theme.window.categoryItemCount}>
                        {`(${categories.reduce(
                            (count, category) => count + category.channels.length,
                            0
                        )})`}
                    </Text>
                </View>
            </Pressable>
            {categories.map((category, index) =>
                !category.channels.length ? undefined : (
                    <Pressable
                        key={`categoryFilter${category.name}`}
                        style={[theme.window.line, { flexDirection: 'row' }]}
                        onPress={() => {
                            onSelected(index);
                            logEvent({
                                type: 'user-flow',
                                subtype: 'epg/genra',
                                content1: '',
                                content2: category.name,
                                context: '/epg'
                            });
                        }}
                    >
                        <View
                            style={{
                                flexDirection: 'row',
                                marginLeft: Theme.BU / 2,
                                alignItems: 'center'
                            }}
                        >
                            <Checkbox isChecked={category.selected} />
                            <Text
                                numberOfLines={1}
                                style={[
                                    theme.window.lineText,
                                    category.selected && theme.window.lineTextActive
                                ]}
                            >
                                {category.name}
                            </Text>
                            <Text
                                style={theme.window.categoryItemCount}
                            >{`(${category.channels.length})`}</Text>
                        </View>
                    </Pressable>
                )
            )}
        </ScrollView>
    );
};

export default CategoriesFilterPage;
